import { AgentAsyncActions } from 'store/actions/agent';
import { createReducerFromActions } from 'utils/store';
import { values } from 'lodash';

export default createReducerFromActions(...values(AgentAsyncActions));
